import { render, staticRenderFns } from "./ProviderEmailFilter.vue?vue&type=template&id=7b7138e4&scoped=true&"
import script from "./ProviderEmailFilter.vue?vue&type=script&lang=ts&"
export * from "./ProviderEmailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7138e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
